export const USER_SUCCESS = 'USER_SUCCESS'
export const USER_LOGOUT = 'USER_LOGOUT'
